import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';

import { ScoreReportDto } from 'src/app/core/dtos/dto';
import { BrandEnum, RegStatusEnum } from 'src/app/core/dtos/enum';
import { AccountService } from 'src/app/core/services/account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-check-score',
  templateUrl: './check-score.component.html',
  styleUrls: ['./check-score.component.scss']
})
export class CheckScoreComponent implements OnInit, OnDestroy {

  @ViewChild('downloadErrorModal') downloadErrorModal: ModalComponent;

  brandId: BrandEnum;
  regId: number;
  childAccountId: number;
  launchSRDownload: boolean;
  logo: string;
  scoreInfo: ScoreReportDto;
  scoreSusbcription: Subscription;
  regIdSubscription: Subscription;
  downloadCelpipScoreSubscription: Subscription;
  getScoreError: boolean;
  invalidScoreForIRCC: boolean;
  testLevelDescriptorUrl: string;
  testLevelDescriptorCELPIP = "https://www.celpip.ca/take-celpip/test-results-scoring/#anchor-4";
  testLevelDescriptorCAEL = "https://www.cael.ca/take-cael/test-results-scoring/";

  constructor(
    private configHelper: ConfigHelper,
    private accountService: AccountService,
    private toastService: HotToastService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  public get BrandEnum() {
    return BrandEnum;
  }

  public get RegStatusEnum() {
    return RegStatusEnum;
  }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.launchSRDownload = this.configHelper.getLaunchSRDownload() === 1;
    this.testLevelDescriptorUrl = this.brandId === this.BrandEnum.CELPIP ? this.testLevelDescriptorCELPIP : this.testLevelDescriptorCAEL;
    this.regIdSubscription = this.activatedRoute.params
      .subscribe(
        params => {
          this.regId = params.regId;
          if (params['childAccountId?']) {
            this.getChildScore(params.regId, params['childAccountId?']);
          }
          else {
            this.getScore(params.regId);
          }
        });
  }

  getScore(regId: number) {
    this.scoreSusbcription = this.accountService.checkScores(regId)
      .subscribe(
        result => this.onGetScoreSuccess(result),
        () => this.onGetScoreError()
      );
  }

  getChildScore(regId: number, childAccountId: number) {
    this.scoreSusbcription = this.accountService.checkChildScores(regId, childAccountId)
      .subscribe(
        result => this.onGetScoreSuccess(result),
        () => this.onGetScoreError()
      );
  }

  onGetScoreSuccess(result) {
    this.scoreInfo = result.content;
    if (this.brandId === BrandEnum.CELPIP && !this.scoreInfo.isValidForIRCC) {
      this.invalidScoreForIRCC = true;
    }
    if (this.scoreInfo.testTypeLogo) {
      this.logo = this.configHelper.getImageUrl(this.scoreInfo.testTypeLogo);
    }
    // fix Li styles for detailDescriptorList
    if (this.scoreInfo.components) {
      this.scoreInfo.components.forEach(x => {
        if (x.componentName === "Reading" || x.componentName === "Listening") {
          x.detailDescriptorList = "<li>" + x.detailDescriptorList;
        }
      }
      );
    }
  }

  onGetScoreError() {
    this.getScoreError = true;
    this.toastService.warning("Failed to load test registration score info");
    this.router.navigate(['/my-account']);
  }


  downloadCelpipScoreReport() {
    const testDate = this.scoreInfo.regInfo.testDateTime;
    const timeDiff = Math.abs(Date.now() - + new Date(testDate));
    const diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
    if (diffDays > 730) {
      this.downloadErrorModal.open();
    }
    else {
      this.downloadCelpipScoreSubscription = this.accountService.downloadCelpipScoreReport(this.regId)
        .subscribe(
          res => {
            const dataType = res.type;
            const blob = new Blob([res], { type: dataType });
            const data = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');
            downloadLink.href = data;
            downloadLink.setAttribute('download', `${this.regId}.pdf`);
            downloadLink.click();
          }
          ,
          () => {
            this.toastService.warning('Unable to download score');
          }
        );
    }
  }

  ngOnDestroy(): void {
    this.scoreSusbcription?.unsubscribe();
    this.downloadCelpipScoreSubscription?.unsubscribe();
  }

}
